import { i18n } from './lang'
import { logUserAction } from './utils/logging'
window.axios = require('axios')
window.qs = require('qs')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const getRequestId = async () => {
  if (!sessionStorage.getItem('request_id')) {
    const urlParams = new URLSearchParams(window.location.search)
    if (!urlParams.get('request_id')) {
      try {
        const requestId = await axios.get('/landingpage?controller=request_id')
        sessionStorage.setItem('request_id', requestId.data.request_id)
      } catch (error) {
        console.error(error)
        return 'undefined-request-id'
      }
    } else {
      sessionStorage.setItem('request_id', urlParams.get('request_id'))
    }
  }

  return sessionStorage.getItem('request_id')
}

axios.interceptors.request.use((config) => {
  if (config.url === '/landingpage?controller=request_id') {
    return config
  }

  getRequestId().then((requestId) => {
    config.headers['X-Request-Id'] = requestId
  })

  logUserAction({ type: 'api', url: config.url, method: config.method })

  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('[Interceptor RESPONSE] init')
    const errorText = error.response?.data?.error || error.response?.data?.message || ''
    console.log('[Interceptor RESPONSE] errorText', errorText)

    getRequestId().then((requestId) => {
      console.log('[Interceptor RESPONSE] requestId', requestId)

      const errorReferenceHtml = `<p>${i18n.t('error_reference')}: ${requestId}</p>`
      const referenceIdText = errorText ? `<br>${errorReferenceHtml}` : errorReferenceHtml

      console.log('[Interceptor RESPONSE] referenceIdText', {
        referenceIdText,
      })

      if (!error.response) {
        console.log('[Interceptor RESPONSE] case 1')
        return Promise.reject(error)
      } else if (!error.response.data) {
        console.log('[Interceptor RESPONSE] case 2')
        error.response.data = {
          meta: errorText + referenceIdText,
        }
      } else if (typeof error.response.data === 'string') {
        console.log('[Interceptor RESPONSE] case 3')
        error.response.data = {
          meta: i18n.t(errorText) + referenceIdText,
        }
      } else {
        console.log('[Interceptor RESPONSE] case 4')
        error.response.data.meta = errorText + referenceIdText
      }

      console.log('[Interceptor RESPONSE] final error state', error)
    })

    return Promise.reject(error)
  },
)
